// FLAGS: none
// The router basename the boot chose — the language prefix of the address the page booted on, or none — and whether
// prefix routing is on for this page load. Its own module so readers (the entry point, the Phase Two sign-in) do not
// import the whole boot sequence.
let routerBasename: string | undefined;
let prefixRouting = false;

// Called once by the boot, after the LanguagePathPrefix flag is known.
export const setRouterBasename = (
  value: string | undefined,
  languagePathPrefix = false,
): void => {
  routerBasename = value;
  prefixRouting = languagePathPrefix;
};

// What the router mounts with; `undefined` before the boot has run.
export const getRouterBasename = (): string | undefined => routerBasename;

// Whether this page load routes by language prefix — the LanguagePathPrefix flag as the boot read it.
export const isPrefixRoutingOn = (): boolean => prefixRouting;
